import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import ReactPlayer from 'react-player';
import HeaderBack from '../../../../components/mobile/HeaderBack';
import { Typography } from 'antd';

const { Paragraph } = Typography;

function MobileVideoDetailScreen() {
  const { t } = useTranslation(['knowledge-bank', 'common']);
  const history = useHistory();

  const onBack = () => {
    history.push('/knowledge-bank/detail/video')
  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('knowledge-bank:goBack')}
        title={'Video 01'}
      />
      <Paragraph style={styles.paragraph}>
        Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up
      </Paragraph>
      <Box marginTop={26} marginBottom={26} height="500px">
        <ReactPlayer
          width='100%'
          height='100%'
          url={"https://www.youtube.com/watch?v=k0EBQioLCR0"}
          playing={true}
        />
      </Box>
    </>
  );
}

const styles = {
  paragraph: {
    fontWeight: "300", 
    fontSize: "14px", 
    lineHeight: "20px", 
    textAlign: "center", 
    color: "#8C8C8C"
  }
}

export default MobileVideoDetailScreen;
